import React from 'react';
import { useBooking } from '../../../../../../../contexts/ticketBookingContext/TicketBookingContext';
import FillPassengersNavigation from '../../../bookingNavigationSteps/FillPassengersNavigation';

function CompleteStatementBookingNavigationTabItems() {
  const {
    departurePassengersForm,
    returnPassengersForm,
    statement,
  } = useBooking();

  return [{
    key: 1,
    children: <FillPassengersNavigation
      departureForm={departurePassengersForm}
      returnForm={returnPassengersForm}
    />,
  }, {
    key: 2,
    children: statement?.id ? (
      <FillPassengersNavigation
        statement={statement}
      />
    ) : (
      <FillPassengersNavigation
        departureForm={departurePassengersForm}
        returnForm={returnPassengersForm}
      />
    ),
  }, {
    key: 3,
    children: <FillPassengersNavigation
      statement={statement}
    />,
  },
  ];
}

export default CompleteStatementBookingNavigationTabItems;
